import { cn } from '@heidi/utils';

import { typographyVariant } from '../typography';

export const alertDialogOverlayClasses =
  'fixed inset-0 z-50 bg-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';

export const alertDialogContentClasses =
  'fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-surface-elevated-border bg-surface-elevated p-6 shadow-dialog duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-2xl';

export const alertDialogHeaderClasses =
  'flex flex-col space-y-2 text-center sm:text-start';

export const alertDialogFooterClasses =
  'flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-2';

export const alertDialogTitleClasses = typographyVariant({ variant: 'h4' });

export const alertDialogDescriptionClasses = cn(
  typographyVariant({ variant: 'p2' }),
  'text-text-secondary'
);

export const alertDialogCancelClasses = 'mt-2 sm:mt-0';
